// @flow
import React, { useState, useEffect, useContext } from 'react';
import { Button, Card } from 'react-bootstrap';
import moment from 'moment';
import ModFinYear from './ModFinYear';
import { checkAccess } from '../../helpers/details';
import { AuthContext } from '../../auth/AuthContext';
const calcularDiasVacaciones = (antiguedad) => {
    if (antiguedad < 1) {
        return 0; // No aplica vacaciones para antigüedad menor a 1 año
    } else if (antiguedad === 1) {
        return 12;
    } else if (antiguedad === 2) {
        return 14;
    } else if (antiguedad === 3) {
        return 16;
    } else if (antiguedad === 4) {
        return 18;
    } else if (antiguedad === 5) {
        return 20;
    } else if (antiguedad >= 6 && antiguedad <= 10) {
        return 22;
    } else if (antiguedad >= 11 && antiguedad <= 15) {
        return 24;
    } else if (antiguedad >= 16 && antiguedad <= 20) {
        return 26;
    } else if (antiguedad >= 21 && antiguedad <= 25) {
        return 28;
    } else if (antiguedad >= 26 && antiguedad <= 30) {
        return 30;
    } else if (antiguedad >= 31 && antiguedad <= 35) {
        return 32;
    } else {
        return 0; // Ajustar según las políticas si la antigüedad es mayor a 35 años
    }
};

const SellerBox = ({ data }) => {
    const { auth } = useContext(AuthContext);

    const permisos = checkAccess('Empleados', auth.accesos);

    const { nom_fin } = permisos.functions;
    const { inicio_labores, sueldo } = data;
    const [show, setShow] = useState(false);
    const [diasVacaciones, setDiasVacaciones] = useState(0);
    const [primaVacacional, setPrimaVacacional] = useState(0);
    const [aguinaldo, setAguinaldo] = useState(0);
    const [total, setTotal] = useState(0);
    const [finanio, setFinanio] = useState({
        total,
        aguinaldo,
        primaVacacional,
        diasVacaciones,
    });

    useEffect(() => {
        // Obtener los días trabajados
        const diasTrabajados = moment().diff(moment(inicio_labores), 'days');

        // Calcular años de servicio
        const aniosServicio = moment().diff(moment(inicio_labores), 'years');

        // Calcular días de vacaciones
        let diasVac;
        if (aniosServicio < 1) {
            diasVac = Math.round((12 / 365) * diasTrabajados);
        } else {
            diasVac = Math.round(calcularDiasVacaciones(aniosServicio));
        }
        console.log('DISAS', diasTrabajados, sueldo);

        // Calcular prima vacacional (25% de los días de vacaciones)
        const primaVac = diasVac * sueldo * 0.25;

        // Calcular aguinaldo
        let aguinaldo;
        if (aniosServicio < 1) {
            aguinaldo = (15 / 365) * diasTrabajados * sueldo;
        } else {
            aguinaldo = sueldo * 15;
        }

        // Calcular el total
        const total = diasVac * sueldo + primaVac + aguinaldo;

        // Actualizar los estados
        setDiasVacaciones(diasVac);
        setPrimaVacacional(primaVac);
        setAguinaldo(aguinaldo);
        setTotal(total);
    }, [inicio_labores, sueldo]);

    useEffect(() => {
        setFinanio({
            total,
            aguinaldo,
            primaVacacional,
            diasVacaciones,
        });
    }, [total, aguinaldo, primaVacacional, diasVacaciones]);

    return (
        <Card>
            <Card.Body id="endyear">
                <h4 className="header-title mt-0 mb-3">Información</h4>

                <hr />

                <div className="text-start">
                    <p className="text-muted">
                        <strong>Antiguedad:</strong> <span className="ms-2">{inicio_labores}</span>
                    </p>
                    <p className="text-muted">
                        <strong>Días de vacaciones:</strong> <span className="ms-2">{diasVacaciones}</span>
                    </p>

                    <p className="text-muted">
                        <strong>Días pagados vacaciones:</strong>
                        <span className="ms-2">${Math.round((diasVacaciones * sueldo).toFixed(2))}</span>
                    </p>

                    <p className="text-muted">
                        <strong>Prima vacacional:</strong>{' '}
                        <span className="ms-2">${Math.round(primaVacacional.toFixed(2))}</span>
                    </p>

                    <p className="text-muted">
                        <strong>Aguinaldo:</strong> <span className="ms-2">${Math.round(aguinaldo.toFixed(2))}</span>
                    </p>

                    <p className="text-muted mb-0">
                        <strong>Total:</strong> <span className="ms-2">${Math.round(total.toFixed(2))}</span>
                    </p>
                </div>
                {nom_fin && <Button onClick={() => setShow(true)}>Imprimir</Button>}
            </Card.Body>
            <ModFinYear show={show} onClose={() => setShow(false)} dia={data.sueldo} user={data} finanio={finanio} />
        </Card>
    );
};

export default SellerBox;
